module.exports = __webpack_public_path__ + "static/media/Reuben.4f4a0aa1.png";